/* Memento デザイン（2026-10 刷新）の小さな動き
   - 目次：本文の見出し2から作る（data-mm-toc）
   - よくある質問：「よくある質問」見出しのあとの見出し3＋答えを開け閉めの形にする
   - スマホの「カートに追加」固定ボタン */
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  // 目次
  function buildToc() {
    document.querySelectorAll('[data-mm-toc]').forEach(function (toc) {
      var target = document.querySelector(toc.getAttribute('data-mm-toc'));
      var min = parseInt(toc.getAttribute('data-mm-toc-min') || '3', 10);
      if (!target) return toc.remove();
      var hs = Array.prototype.filter.call(target.querySelectorAll('h2'), function (h) {
        return !h.closest('.mm-acc');
      });
      if (hs.length < min) return toc.remove();
      // 本文の最初の段落のあとに置く
      if (toc.getAttribute('data-mm-toc-place') === 'after-first-p') {
        var first = target.querySelector(':scope > p');
        if (first) first.after(toc);
        else target.prepend(toc);
      }
      var ol = toc.querySelector('ol');
      hs.forEach(function (h, i) {
        if (!h.id) h.id = 'mm-s' + (i + 1);
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = '#' + h.id;
        a.textContent = h.textContent.trim();
        li.appendChild(a);
        ol.appendChild(li);
      });
      toc.hidden = false;
    });
  }

  // よくある質問を開け閉めの形に
  function buildFaq() {
    document.querySelectorAll('.rte').forEach(function (rte) {
      if (rte.querySelector('.mm-acc')) return;
      Array.prototype.forEach.call(rte.querySelectorAll('h2'), function (h2) {
        if (!/^よくある(ご)?質問/.test(h2.textContent.trim())) return;
        var acc = document.createElement('div');
        acc.className = 'mm-acc';
        var node = h2.nextElementSibling;
        var current = null;
        while (node && node.tagName !== 'H2') {
          var next = node.nextElementSibling;
          if (node.tagName === 'H3') {
            current = document.createElement('details');
            var s = document.createElement('summary');
            s.innerHTML = node.innerHTML;
            current.appendChild(s);
            var a = document.createElement('div');
            a.className = 'mm-acc__a';
            current.appendChild(a);
            acc.appendChild(current);
            node.remove();
          } else if (current && node.tagName === 'P' && current.querySelector('.mm-acc__a').children.length === 0) {
            current.querySelector('.mm-acc__a').appendChild(node);
          } else {
            current = null;
            if (acc.children.length) break;
          }
          node = next;
        }
        if (acc.children.length) h2.after(acc);
      });
    });
  }

  // スマホの「カートに追加」固定ボタン
  function stickyBuy() {
    var bar = document.querySelector('.mm-stickybuy');
    if (!bar) return;
    var main = document.querySelector('product-form .product-form__submit');
    if (!main) return bar.remove();
    var label = bar.querySelector('[data-mm-variant]');
    var btn = bar.querySelector('button');
    function sync() {
      var checked = document.querySelector('variant-selects input[type="radio"]:checked');
      var current = document.querySelector('product-form .product-form__submit');
      if (label && checked) label.textContent = checked.value;
      if (!current) return;
      btn.disabled = current.disabled;
      btn.textContent = current.disabled ? (window.variantStrings ? window.variantStrings.soldOut : '売り切れ') : btn.getAttribute('data-label');
    }
    btn.addEventListener('click', function () {
      var current = document.querySelector('product-form .product-form__submit');
      if (current && !current.disabled) current.click();
    });
    // 本来のボタンが画面の上に流れたら出す（色を選ぶとボタンが作り直されるので、毎回探す）
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var current = document.querySelector('product-form .product-form__submit');
        if (current) bar.classList.toggle('is-show', current.getBoundingClientRect().bottom < 0);
        ticking = false;
      });
    }, { passive: true });
    document.addEventListener('change', function () { setTimeout(sync, 400); });
    sync();
  }

  // 色別ページ：選んでいる色のボタンが、横スクロールの中で見える位置に来るようにする
  function colorNav() {
    var list = document.querySelector('.mm-colors--chips');
    var on = list && list.querySelector('.is-on');
    if (!on || list.scrollWidth <= list.clientWidth) return;
    list.scrollLeft = Math.max(0, on.offsetLeft - list.offsetLeft - (list.clientWidth - on.offsetWidth) / 2);
  }

  ready(function () {
    buildFaq();
    buildToc();
    stickyBuy();
    colorNav();
  });
})();
